import { useState, useEffect, useCallback } from "react";
import {
  PresetListModel,
  SocialPresetModel,
} from "@/database";

interface UsePresetManagementProps {
  item?: PresetListModel;
  presetDetails?: SocialPresetModel[];
  handleAllSocialPresets?: (presets: any[]) => void;
}

interface UsePresetManagementReturn {
  allSelectedPresets: any[];
  presetSelected: any[];
  handleAllSelectedPresets: (presets: any) => void;
  setAllSelectedPresets: React.Dispatch<React.SetStateAction<any[]>>;
}

export const usePresetManagement = ({
  item,
  presetDetails,
  handleAllSocialPresets,
}: UsePresetManagementProps): UsePresetManagementReturn => {
  const [allSelectedPresets, setAllSelectedPresets] = useState<any[]>(
    item?.social || []
  );
  const [presetSelected, setPresetSelected] = useState<any[]>(
    presetDetails || []
  );

  const handleAllSelectedPresets = useCallback((presets: any) => {
    setAllSelectedPresets((prevPresets) => {
      // Create a new array to avoid mutating the previous state
      const updatedPresets = [...prevPresets];

      // Find if there's an existing preset with the same channel_name
      const existingIndex = updatedPresets.findIndex(
        (existingPreset) => existingPreset.channel_name === presets.channel_name
      );

      if (existingIndex !== -1) {
        // Replace the existing preset with the new one
        updatedPresets[existingIndex] = presets;
      } else {
        // Add the new preset if no matching channel_name found
        updatedPresets.push(presets);
      }

      return updatedPresets;
    });
  }, []);

  // Notify parent component when allSelectedPresets changes
  useEffect(() => {
    if (handleAllSocialPresets) {
      handleAllSocialPresets(allSelectedPresets);
    }
  }, [allSelectedPresets, handleAllSocialPresets]);

  // Update presetSelected when presetDetails changes
  useEffect(() => {
    setPresetSelected(presetDetails || []);
  }, [presetDetails]);

  // Update allSelectedPresets when item changes
  useEffect(() => {
    setAllSelectedPresets(item?.social || []);
  }, [item]);

  return {
    allSelectedPresets,
    presetSelected,
    handleAllSelectedPresets,
    setAllSelectedPresets,
  };
};
